globalThis.HUB_ORIGIN = "https://platfo-hub.fly.dev";

globalThis.ANIMATION_STEP = 33;
globalThis.PHYSICS_STEP = 16;
globalThis.CARD_HEIGHT = 180;
globalThis.CARD_WIDTH = 240;
globalThis.DOUBLE_PRESS_TIMEOUT = 200;
globalThis.DRAG = 0.2;
globalThis.GRAVITY = 0.9;
globalThis.LOCK_DURATION = 3000;
globalThis.MAX_FALLING_SPEED = 15;
globalThis.SCALE_MAX = 1.5;
globalThis.SCALE_MIN = 0.5;
globalThis.SCALE_STEP = 0.1;
globalThis.TOPBAR_HEIGHT = 44;
globalThis.UNIT = 32;

globalThis.BASE64 =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

globalThis.PLAYER_ANIMATIONS = {
  STANDING: [new Vector2(0, 0)],
  WALKING: [
    new Vector2(1, 0),
    new Vector2(2, 0),
    new Vector2(3, 0),
    new Vector2(4, 0),
    new Vector2(5, 0),
    new Vector2(6, 0),
  ],
  RUNNING: [
    new Vector2(1, 1),
    new Vector2(2, 1),
    new Vector2(3, 1),
    new Vector2(4, 1),
    new Vector2(5, 1),
    new Vector2(6, 1),
  ],
  JUMPING: [new Vector2(0, 2), new Vector2(1, 2), new Vector2(2, 2)],
};
globalThis.PLAYER_ANIMATIONS.JUMPING.hanging = true;

globalThis.PLAYER_CONTROLS = [
  [37, 40, 38, 39],
  [65, 83, 87, 68],
  [74, 75, 73, 76],
];

globalThis.ICONS = {
  MENU: new Vector2(0, 0),
  CAMERA: new Vector2(1, 0),
  PEN: new Vector2(2, 0),
  DEBUG: new Vector2(3, 0),
  CAMERALOCK: new Vector2(4, 0),
};

globalThis.BLOCKS = 24;
globalThis.BLOCK_CONFIG = [
  { color: "black" },
  { color: "red" },
  { color: "green" },
  { color: "yellow" },
  { color: "blue" },
  { color: "magenta" },
  { color: "cyan" },
  { color: "white" },
  { passthrough: true, gravity: new Vector2() },
  { passthrough: true, gravity: new Vector2(-1.5, 0) },
  { passthrough: true, gravity: new Vector2(0, 1.5) },
  { passthrough: true, gravity: new Vector2(0, -1.5) },
  { passthrough: true, gravity: new Vector2(1.5, 0) },
  { passthrough: true, key: 1 },
  { passthrough: true, key: 2 },
  { passthrough: true, key: 3 },
  { passthrough: true, start: true },
  { passthrough: true, finish: true },
  { passthrough: true, unlock: 1 },
  { passthrough: true, unlock: 2 },
  { passthrough: true, unlock: 3 },
  { lock: 1 },
  { lock: 2 },
  { lock: 3 },
];

globalThis.WORLD_SIZES = [
  "32x8",
  "16x16",
  "32x16",
  "64x16",
  "32x32",
  "64x32",
  "64x64",
  "96x32",
];
